import { Input } from "components/ui/input";
import { Label } from "components/ui/label";
import React from "react";
import { PasswordConfigurationTypeEnum } from './config';
import { CardSubtitle } from 'components/ui/card';
import { CornerDownRightIcon } from 'lucide-react';
import { RadioGroup, RadioGroupItem } from 'components/ui/radio-group';

interface PasswordInputProps {
    value: string;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    disabled?: boolean;
    hidden?: boolean;          // renomeei p/ deixar a intenção mais clara
    error?: string[] | undefined;
    numericOnly?: boolean;   // 👈 novo prop
    maxLength?: number;        // opcional, default 5
}


interface PasswordConfigurationOptionsProps {
    title: string;
    passwordType: string;
    onPasswordTypeChange: (value: PasswordConfigurationTypeEnum) => void;
    isSubSection?: boolean;
}

export const PasswordConfigurationOptions: React.FC<PasswordConfigurationOptionsProps> = ({
    title,
    passwordType,
    onPasswordTypeChange,
    isSubSection = true,

}) => (
    <div className="space-y-2">
        <CardSubtitle className="flex items-center gap-1 relative">
            <CornerDownRightIcon className={"absolute left-[-28px] top-1/2 -translate-y-1/2 text-primary w-5 h-5" + (isSubSection ? " block" : " hidden")} />
            {title}
        </CardSubtitle>

        <RadioGroup
            value={passwordType}
            onValueChange={onPasswordTypeChange}
            className="space-y-2"
        >
            <div className="flex items-center space-x-2">
                <RadioGroupItem value={PasswordConfigurationTypeEnum.AUTOMATIC} id="automatic" />
                <Label htmlFor="automatic" className="font-normal">
                    Definir senha automática
                </Label>
            </div>
            <div className="flex items-center space-x-2">
                <RadioGroupItem value={PasswordConfigurationTypeEnum.MANUAL} id="manual" />
                <Label htmlFor="manual" className="font-normal">
                    Definir senha manual
                </Label>
            </div>
        </RadioGroup>
    </div>
);
export const PasswordInput: React.FC<PasswordInputProps> = ({
    value,
    onChange,
    disabled = false,
    hidden = false,
    error,
    numericOnly = false,
    maxLength = 5,
}) => {
    // regex que remove tudo que não é permitido
    const sanitizeRegex = numericOnly ? /[^0-9]/g : /[^A-Za-z0-9]/g;

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        let newValue = e.target.value.replace(sanitizeRegex, "");

        // limita o tamanho, se desejado
        if (maxLength) newValue = newValue.slice(0, maxLength);

        // repassa o evento com o valor já limpo
        onChange({
            ...e,
            target: { ...e.target, value: newValue },
        });
    };

    // se o componente estiver oculto, não renderiza nada
    if (hidden) return null;

    return (
        <div className="space-y-2">
            <Label htmlFor="manual-password" className="block text-sm font-medium">
                Senha Manual
            </Label>

            <Input
                id="manual-password"
                type="text"
                value={value}
                disabled={disabled}
                onChange={handleChange}
                placeholder="Digite a senha manual"
                className="disabled:opacity-50 disabled:cursor-not-allowed"
                inputMode={numericOnly ? "numeric" : "text"}      // 👈 teclado numérico
                pattern={numericOnly ? "[0-9]+" : "[A-Za-z0-9]+"} // 👈 validação nativa
                maxLength={maxLength}
            />

            {error && (
                <p className="text-red-500 text-sm mt-1">{error.join(", ")}</p>
            )}
        </div>
    );
};
